import { useEffect } from "react";

export default function AdminLoginPage() {
  useEffect(() => {
    document.title = "Admin sign in — JustAirFry";
  }, []);

  const onSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
      <div
        className="w-full max-w-md rounded-2xl p-10 text-center"
        style={{
          backgroundColor: "#fff",
          border: "1px solid var(--jaf-border)",
          boxShadow: "0 24px 60px -36px rgba(44,40,37,0.18)",
        }}
      >
        <span
          className="inline-flex h-12 w-12 items-center justify-center rounded-full mb-5"
          style={{ backgroundColor: "var(--jaf-primary)" }}
        >
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="3" width="14" height="18" rx="3" />
            <circle cx="12" cy="13" r="3.5" />
            <path d="M9 6h6" />
          </svg>
        </span>
        <h1 className="font-serif text-3xl mb-2">Welcome back, chef.</h1>
        <p className="text-sm mb-7" style={{ color: "var(--jaf-text-muted)" }}>
          Sign in to publish recipes and manage the kitchen.
        </p>
        <button
          type="button"
          onClick={onSignIn}
          data-testid="google-signin-btn"
          className="w-full h-12 rounded-md font-medium text-sm inline-flex items-center justify-center gap-3 transition-all hover:bg-[color:var(--jaf-surface)]"
          style={{
            backgroundColor: "#fff",
            border: "1px solid var(--jaf-border)",
            color: "var(--jaf-text)",
          }}
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 14-5.5l-6.5-5.3C29.6 34.8 27 36 24 36c-5.3 0-9.8-3.3-11.4-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.4l6.5 5.3c-.5.4 7.2-5.3 7.2-14.7 0-1.2-.1-2.3-.4-3.5z"/>
          </svg>
          Sign in with Google
        </button>
        <p className="text-xs mt-5" style={{ color: "var(--jaf-text-muted)" }}>
          The first Google account to sign in is automatically set as the site admin.
        </p>
      </div>
    </div>
  );
}
